/**
 * Created by esenckewitch on 3/3/2026.
 */

const OKBridgePayments = function () {
    VKPayments.call(this, connector.OKBRIDGE, {
        source: connector.OKBRIDGE
    });
};

OKBridgePayments.prototype = Object.create(VKPayments.prototype);
OKBridgePayments.prototype.constructor = OKBridgePayments;

OKBridgePayments.prototype.getDefaultCurrency = function () {
    return "OK";
};

OKBridgePayments.prototype.getTextPrice = function (price) {
    return `${price} OK`;
};

OKBridgePayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.OKBRIDGE);
};